import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledButton = styled.button`
  height: 38px;
  width: 102px;
  border: 1px solid black;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
`;
const StyledLink = styled(Link)`
  text-decoration: none;
  color: black;
  &:hover {
    text-decoration: underline;
  }
  &:visited {
    color: black;
  }
`;

const ButtonContact = () => (
  <>
    <StyledButton>
      <StyledLink to="/form">Kontakt</StyledLink>
    </StyledButton>
  </>
);

export default ButtonContact;
